import { Container, Icon, Spinner, TypoGraph } from 'components'
import colors from 'theme/colors'

interface SummaryMetrics {
  riskIndex?: number | null
  harshEventsIndex?: number | null
  geographicIndex?: number | null
  speedIndex?: number | null
}

interface NbDetailsSummaryProps {
  summaryData?: SummaryMetrics
  assetCount: number | undefined
  loading: boolean
  testIdPrefix: string
  styles: { readonly [key: string]: string }
}

const NbDetailsSummary: React.FC<NbDetailsSummaryProps> = ({
  summaryData,
  assetCount,
  loading,
  testIdPrefix,
  styles,
}) => (
  <Container className={styles.summaryMainContainer} data-testid={`${testIdPrefix}-summary-section`}>
    <Container className={styles.summaryHeaderContainer}>
      {(loading && <Spinner data-testid={`${testIdPrefix}-summary-loading`} />) || (
        <Container className={styles.summaryList} data-testid={`${testIdPrefix}-summary-list`}>
          {/* Summary */}
          <Container className={styles.itemContainer} data-testid={`${testIdPrefix}-summary-risk-index`}>
            <Icon name="summary_carriers" size={32} />
            <Container className={styles.summaryContentContainer}>
              <TypoGraph variant="subtitle2" color={colors.white} content="Summary" />
              <Container className={styles.summaryDataContainer}>
                <TypoGraph
                  color={colors.white}
                  content={summaryData?.riskIndex?.toFixed(2) ?? '—'}
                  dataTestId={`${testIdPrefix}-summary-risk-index-value`}
                />
              </Container>
            </Container>
          </Container>
          {/* Harsh Index */}
          <Container className={styles.itemContainer} data-testid={`${testIdPrefix}-summary-harsh-index`}>
            <Icon name="summary_harsh" size={32} />
            <Container className={styles.summaryContentContainer}>
              <TypoGraph variant="subtitle2" color={colors.white} content="Harsh Index" />
              <Container className={styles.summaryDataContainer}>
                <TypoGraph
                  color={colors.white}
                  content={summaryData?.harshEventsIndex?.toFixed(2) ?? '—'}
                  dataTestId={`${testIdPrefix}-summary-harsh-index-value`}
                />
              </Container>
            </Container>
          </Container>
          {/* Geo Index */}
          <Container className={styles.itemContainer} data-testid={`${testIdPrefix}-summary-geo-index`}>
            <Icon name="summary_geo" size={32} />
            <Container className={styles.summaryContentContainer}>
              <TypoGraph variant="subtitle2" color={colors.white} content="Geo Index" />
              <Container className={styles.summaryDataContainer}>
                <TypoGraph
                  color={colors.white}
                  content={summaryData?.geographicIndex?.toFixed(2) ?? '—'}
                  dataTestId={`${testIdPrefix}-summary-geo-index-value`}
                />
              </Container>
            </Container>
          </Container>
          {/* Speed Index */}
          <Container className={styles.itemContainer} data-testid={`${testIdPrefix}-summary-speed-index`}>
            <Icon name="summary_speed" size={32} />
            <Container className={styles.summaryContentContainer}>
              <TypoGraph variant="subtitle2" color={colors.white} content="Speed Index" />
              <Container className={styles.summaryDataContainer}>
                <TypoGraph
                  color={colors.white}
                  content={summaryData?.speedIndex?.toFixed(2) ?? '—'}
                  dataTestId={`${testIdPrefix}-summary-speed-index-value`}
                />
              </Container>
            </Container>
          </Container>
          {/* Active Assets */}
          <Container className={styles.itemContainer} data-testid={`${testIdPrefix}-summary-active-assets`}>
            <Icon name="summary_assets" size={32} />
            <Container className={styles.summaryContentContainer}>
              <TypoGraph variant="subtitle2" color={colors.white} content="Active Assets" />
              <Container className={styles.summaryDataContainer}>
                <TypoGraph
                  color={colors.white}
                  content={assetCount?.toString() ?? '0'}
                  dataTestId={`${testIdPrefix}-summary-active-assets-value`}
                />
              </Container>
            </Container>
          </Container>
          {/* Total Assets */}
          <Container className={styles.itemContainer} data-testid={`${testIdPrefix}-summary-total-assets`}>
            <Icon name="summary_assets" size={32} />
            <Container className={styles.summaryContentContainer}>
              <TypoGraph variant="subtitle2" color={colors.white} content="Total Assets" />
              <Container className={styles.summaryDataContainer}>
                <TypoGraph
                  color={colors.white}
                  content={assetCount?.toString() ?? '0'}
                  dataTestId={`${testIdPrefix}-summary-total-assets-value`}
                />
              </Container>
            </Container>
          </Container>
        </Container>
      )}
    </Container>
  </Container>
)

export default NbDetailsSummary
